import type { GetStaticProps } from 'next'

import { Layout } from '~/components/Layout'
import CLIHero from '~/sections/CLI/CLIHero'
import CLIEntry from '~/sections/CLI/CLIEntry'
import CLIGettingStarted from '~/sections/CLI/CLIGettingStarted'
import Companies from '~/sections/Companies/Companies'
import Community from '~/sections/Community/Community'
import TweetSection from '~/sections/Tweets/TweetSection'
import { getHttpieRepoStargazers, getOverallStargazers } from '~/lib/useStargazers'
import { PageProps } from '~/lib/types'
import { getLayoutProps } from '~/lib/layout'
import { CLI_DESCRIPTION, CLI_SHARE_IMAGE } from '~/lib/seo'
import { GITHUB_ALL_PUBLIC_REPOS } from '~/data'

export const getStaticProps: GetStaticProps = () => ({
  props: {
    orgRepoStargazers: getOverallStargazers(GITHUB_ALL_PUBLIC_REPOS),
    httpieRepoStargazers: getHttpieRepoStargazers(GITHUB_ALL_PUBLIC_REPOS),
    layoutProps: getLayoutProps(),
  },
})

interface Props extends PageProps {
  orgRepoStargazers: number
  httpieRepoStargazers: number | undefined
}

const CLI: React.FC<Props> = ({ orgRepoStargazers, layoutProps, httpieRepoStargazers }) => {
  return (
    <Layout
      {...layoutProps}
      titleTemplate={null}
      title='HTTPie CLI: HTTP & API testing client'
      description={CLI_DESCRIPTION}
      shareImage={CLI_SHARE_IMAGE}
    >
      <CLIHero httpieRepoStargazers={httpieRepoStargazers} />
      <CLIEntry />
      <CLIGettingStarted />
      <TweetSection />
      <Companies />
      <Community orgRepoStargazers={orgRepoStargazers} />
    </Layout>
  )
}

export default CLI
